import { COMAGIC_ID_KEY, chatEvents, getComagicId } from "@/constants"
import { useLayoutEffect, useState } from "react"

interface Props {
  openChat: () => void
  closeChat: () => void
}

export function useExternalChatEvents(props: Props) {
  const { openChat, closeChat } = props

  const [comagicId, setComagicId] = useState(() => localStorage.getItem(COMAGIC_ID_KEY) || getComagicId() || null)

  useLayoutEffect(() => {
    const handleExternalMessage = (event: MessageEvent) => {
      if (event.data?.type === chatEvents.OPEN_CHAT) openChat()
      if (event.data?.type === chatEvents.CLOSE_CHAT) closeChat()
      if (event.data?.type === chatEvents.COMAGIC_ID) {
        const comagicId = event.data.comagicId
        if (comagicId) {
          setComagicId(comagicId)
          localStorage.setItem(COMAGIC_ID_KEY, comagicId)
        }
      }
    }

    window.addEventListener("message", handleExternalMessage)

    return () => {
      window.removeEventListener("message", handleExternalMessage)
    }
  }, [openChat, closeChat])

  return { comagicId }
}
